export const selectSocmedSkip = state => state.preferences.socmedSkip;
export const selectPreferences = state => state.preferences;
export const selectPreferencesTour = state => state.preferences.tour;
